import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { ScanModeData } from '../types/ScanModeData';

export abstract class PackageScanModesFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getScanModes(): ScanModeData[];

  public abstract getSimpleScanModes(): ScanModeData[];

  public abstract getEc2ScanModes(): ScanModeData[];
}
